import React, { useEffect, useState } from 'react';

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    // Function to hide Tawk.to branding
    const hideTawkBranding = () => {
      try {
        // Hide branding via CSS by targeting iframe content
        const style = document.createElement('style');
        style.innerHTML = `
          /* Hide Tawk.to branding in all scenarios */
          iframe[title*="chat"] a[href*="tawk.to"],
          iframe[title*="chat"] .tawk-branding,
          iframe[title*="chat"] [class*="branding"],
          iframe[title*="chat"] div[style*="tawk.to"] {
            display: none !important;
            visibility: hidden !important;
            opacity: 0 !important;
            height: 0 !important;
            width: 0 !important;
          }
        `;
        document.head.appendChild(style);

        // Try to access iframe and hide branding directly
        setTimeout(() => {
          const iframes = document.querySelectorAll('iframe[title*="chat"]');
          iframes.forEach(iframe => {
            try {
              const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
              if (iframeDoc) {
                const brandingElements = iframeDoc.querySelectorAll('a[href*="tawk.to"], [class*="branding"]');
                brandingElements.forEach(el => {
                  el.style.display = 'none';
                  el.style.visibility = 'hidden';
                  el.style.opacity = '0';
                });
              }
            } catch (e) {
              // Cross-origin iframe, CSS will handle it
              console.log('Using CSS to hide branding (cross-origin iframe)');
            }
          });
        }, 1000);
      } catch (error) {
        console.log('Branding removal handled via CSS');
      }
    };

    // Get Tawk.to credentials from environment variables
    const tawkPropertyId = process.env.REACT_APP_TAWK_PROPERTY_ID;
    const tawkWidgetId = process.env.REACT_APP_TAWK_WIDGET_ID;

    // Only load if both IDs are configured
    if (!tawkPropertyId || !tawkWidgetId) {
      console.log('Tawk.to not configured. Add REACT_APP_TAWK_PROPERTY_ID and REACT_APP_TAWK_WIDGET_ID to .env file');
      return;
    }

    // Prevent duplicate initialization
    if (window.Tawk_API && window.Tawk_API.isChatMaximized !== undefined) {
      console.log('Tawk.to already loaded');
      window.Tawk_API.showWidget();
      hideTawkBranding();
      return;
    }

    // Tawk.to integration
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    const loadTawk = () => {
      // Check if script already exists
      const existingScript = document.querySelector('script[src*="tawk.to"]');
      if (existingScript) {
        console.log('Tawk.to script already exists');
        if (window.Tawk_API) {
          window.Tawk_API.showWidget();
          hideTawkBranding();
        }
        return;
      }

      var s1 = document.createElement("script");
      var s0 = document.getElementsByTagName("script")[0];
      
      s1.async = true;
      s1.src = `https://embed.tawk.to/${tawkPropertyId}/${tawkWidgetId}`;
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
      
      // Show default Tawk.to widget and hide branding
      s1.onload = function() {
        if (window.Tawk_API) {
          // Show the default Tawk.to widget
          window.Tawk_API.showWidget();
          
          // Listen for unread messages
          window.Tawk_API.onUnreadCountChanged = function(count) {
            setUnreadCount(count);
          };

          // Hide branding when widget loads
          window.Tawk_API.onLoad = function() {
            window.Tawk_API.showWidget();
            // Hide branding after widget loads
            hideTawkBranding();
          };

          // Hide branding when chat is maximized
          window.Tawk_API.onChatMaximized = function() {
            setTimeout(hideTawkBranding, 500);
          };
        }
      };

      s0.parentNode.insertBefore(s1, s0);
    };

    loadTawk();

    return () => {
      // Cleanup if needed
    };
  }, []);

  const toggleChat = () => {
    if (window.Tawk_API) {
      if (isOpen) {
        window.Tawk_API.minimize();
      } else {
        window.Tawk_API.maximize();
      }
      setIsOpen(!isOpen);
    }
  };

  return (
    <div className="custom-chat-widget">
      <button 
        className="custom-chat-button" 
        onClick={toggleChat}
        aria-label="Open chat support"
        title="Chat with us"
      >
        {/* Chat Icon */}
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 24 24" 
          fill="currentColor"
        >
          {isOpen ? (
            // X icon when chat is open
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          ) : (
            // Chat bubble icon when closed
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
          )}
        </svg>
        
        {/* Unread count badge */}
        {unreadCount > 0 && !isOpen && (
          <span className="chat-badge">{unreadCount}</span>
        )}
      </button>
    </div>
  );
};

export default ChatWidget;
